/* eslint-disable */
import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  InputBase,
  IconButton,
  Badge,
  Box,
} from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import {
  Search as SearchIcon,
  FavoriteBorder,
  ShoppingCart,
  Favorite,
} from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../redux/cartSlice";
import { clearWishlist, removeFromWishlist } from "../redux/wishlistSlice";
import ProfileMenu from "./ProfileMenu";
import logo from "../assets/logo.png";

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  position: "static",
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.primary,
}));

const StyledToolbar = styled(Toolbar)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SearchWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: alpha(theme.palette.common.black, 0.05),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.black, 0.1),
  },
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0.5, 2),
  marginRight: theme.spacing(2),
  marginLeft: theme.spacing(3),
  width: "40%",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  flex: 1,
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(4),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
  },
}));

const Navbar = () => {
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cart.items);
  const wishlistItems = useSelector((state) => state.wishlist.wishlist);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const handleCartClick = () => {
    navigate("/cart");
  };

  const handleWishlistClick = () => {
    navigate("/wishlist");
  };

  const handleClearCart = () => {
    dispatch(clearCart());
  };

  const handleClearWishlist = () => {
    dispatch(removeFromWishlist());
  };

  const handleSearch = (event) => {
    event.preventDefault(); // Prevent form submission
    if (searchTerm.trim() !== "") {
      navigate(`/search?q=${encodeURIComponent(searchTerm)}`); // Navigate to search results with query parameter
    }
  };

  return (
    <StyledAppBar position="static">
      <StyledToolbar>
        <Link to="/">
          <Box display="flex" alignItems="center">
            <img
              src={logo}
              alt="Logo"
              style={{ height: 40, marginRight: 16 }}
            />
          </Box>
        </Link>
        <form
          onSubmit={handleSearch}
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <SearchWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <IconButton type="submit" aria-label="search">
              <SearchIcon />
            </IconButton>
          </SearchWrapper>
        </form>
        <Box display="flex" alignItems="center" gap="20px">
          <IconButton
            onClick={handleWishlistClick}
            aria-label="show wishlist items"
            color="inherit"
            sx={{ backgroundColor: "#ccc", borderRadius: "5px" }}
          >
            <Badge badgeContent={wishlistItems.length} color="secondary">
              <Favorite sx={{ color: "#1976D2" }} />
            </Badge>
          </IconButton>
          <IconButton
            onClick={handleCartClick}
            aria-label="show cart items"
            color="inherit"
            sx={{ backgroundColor: "#ccc", borderRadius: "5px" }}
          >
            <Badge badgeContent={cartItems.length} color="secondary">
              <ShoppingCart sx={{ color: "#1976D2" }} />
            </Badge>
          </IconButton>
          <ProfileMenu sx={{ color: "#1976D2" }} />
        </Box>
      </StyledToolbar>
    </StyledAppBar>
  );
};

export default Navbar;
